import React, { useMemo } from "react";
import Loader from "../Loader";
import HelpText from ".";
import Icon from "../Icon";
import Toaster from "../Toaster";
import EditorField from "../Fields/EditorField";
import FormManager from "../FormManager";
import PreventDragButton from "../PreventDragButton";
import branding from "@config/branding";
import classNames from "classnames";
import { useAuthAPI } from "../../common/hooks/useAuthAPI";
import { useSession } from "../Session";
import { useHelpText } from "./Provider";

const HelpTextField = ({
  fieldName,
  className,
  modalClassName,
  removeModalTrapFocus,
  customPermission,
  applicationAreaID
}) => {
  const context = useHelpText();
  const request = useAuthAPI('/api/HelpText');
  const [{
    user
  }] = useSession();
  const permissionToEdit = user?.devUser || customPermission;

  const handleSave = event => {
    event.originalEvent?.stopPropagation();

    if (event.isReady()) {
      const FORM_DATA = event.json();
      const payload = {
        "id": 0,
        "applicationAreaID": applicationAreaID || branding.applicationAreaID,
        "fieldName": fieldName,
        "groupName": context?.groupName,
        "title": FORM_DATA.title,
        "content": FORM_DATA.content
      };
      const toast = Toaster(`Saving Help Text ${FORM_DATA.title}`);
      request.call({
        data: payload
      }).then(response => {
        if (response.data.success) {
          event.setDirty(false);
          context?.refetch();
          toast.success(`Successfully saved ${FORM_DATA.title}`);
        } else {
          FormManager.setBackendValidation(event, response.data.errors);
          toast.fail(response.data.message || branding.messages.fail);
        }
      }).catch(error => {
        toast.error(error?.response.data?.message || branding.messages.error);
      });
    }
  };

  const isDev = permissionToEdit;
  const item = useMemo(() => {
    return context.data?.find(item => item?.FieldName === fieldName);
  }, [context.data]);
  return isDev || !!item ? /*#__PURE__*/React.createElement(HelpText.Modal, {
    as: "span",
    className: className,
    modalClassName: classNames(modalClassName, {
      dev: isDev
    }),
    removeModalTrapFocus: removeModalTrapFocus,
    permissionToEdit: isDev,
    modalBody: /*#__PURE__*/React.createElement(React.Fragment, null, isDev ? /*#__PURE__*/React.createElement(FormManager, {
      id: "help-text-form",
      onSubmit: handleSave
    }, /*#__PURE__*/React.createElement(PreventDragButton, {
      as: "div"
    }, /*#__PURE__*/React.createElement(FormManager.Input, {
      name: "title",
      placeholder: "Enter title",
      value: item?.Title
    }), /*#__PURE__*/React.createElement(FormManager.Input, {
      as: EditorField,
      name: "content",
      value: item?.Content
    })), /*#__PURE__*/React.createElement("div", {
      className: "d-flex justify-content-end"
    }, /*#__PURE__*/React.createElement(PreventDragButton, {
      type: "submit",
      form: "help-text-form",
      loading: request.loading
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "save"
    }), " Save"), /*#__PURE__*/React.createElement(PreventDragButton, {
      type: "button",
      variant: "secondary",
      className: "ml-2",
      disabled: request.loading,
      onClick: e => {
        e.target?.closest('.help-text-modal')?.querySelector('.help-text-close')?.click();
      }
    }, "Cancel"))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "help-text-title"
    }, item?.Title), /*#__PURE__*/React.createElement("div", {
      className: "help-text-content",
      dangerouslySetInnerHTML: {
        __html: item?.Content || ""
      }
    })), /*#__PURE__*/React.createElement(Loader, {
      active: context.loading
    }, /*#__PURE__*/React.createElement("small", {
      className: "mt-4"
    }, "Loading the Help Text data...")))
  }, /*#__PURE__*/React.createElement("img", {
    height: "20px",
    src: "/images/wc/wc-save-info-request.png",
    alt: ""
  })) : null;
};

export default HelpTextField;